import { ChannelMessage, MessageHandler, MessageTypes } from './messengerTypes'

// biome-ignore lint/suspicious/noExplicitAny: Сложная типизация
const getInitial = (): Record<MessageTypes, MessageHandler<any>[]> => ({
  deletePolygonFromProject: [],
  updateCubeLineValue: [],
  fitAllVisualizedObjects: [],
  vspChanged: [],
  undoDelete: [],
  horizonCreated: [],
  elementSelected: [],
  faultCreated: [],
  markerCreated: [],
  markerSelected: [],
  entitiesUpdated: [],
  userLoggedIn: [],
  interpretation3DCreated: [],
  interpretation2DCreated: [],
  elementPublished: [],
  updateHorizonInterpretation: [],
  updateFault: [],
  deleteMarkerFromProject: [],
  updateTabDomain: [],
  updateMarker: [],
  publishElement: [],
  sendObjectTreeElement: [],
})

class Channel {
  // biome-ignore lint/suspicious/noExplicitAny: Сложная типизация
  private handlersDictionary: Record<MessageTypes, MessageHandler<any>[]> = getInitial()

  private eventsHandler<T extends MessageTypes>(e: ChannelMessage<T>) {
    const handlers = this.handlersDictionary[e.type]
    for (const h of handlers) {
      h(e)
    }
  }

  subscribe<T extends MessageTypes>(type: MessageTypes, callback: MessageHandler<T>) {
    if (this.handlersDictionary[type]) {
      this.handlersDictionary[type].push(callback)
    } else {
      this.handlersDictionary[type] = [callback]
    }
    return () => {
      this.handlersDictionary[type] = this.handlersDictionary[type].filter(h => h !== callback)
    }
  }

  send<T extends MessageTypes>(message: ChannelMessage<T>) {
    this.eventsHandler(message)
  }
}

const channel = new Channel()

const send = <T extends MessageTypes>(message: ChannelMessage<T>) => channel.send(message)

const subscribe = <T extends MessageTypes>(type: MessageTypes, callback: MessageHandler<T>) =>
  channel.subscribe(type, callback)

const messenger = { send, subscribe }
export type Messenger = typeof messenger

export default messenger
